import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { assignInstitutes, userInstituteMappingQueryKeys } from '../api/userInstituteMapping.api';
import type { AssignInstitutesPayload } from '../types/userInstituteMapping.types';

export function useAssignInstitutes(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: AssignInstitutesPayload) => assignInstitutes(payload),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: userInstituteMappingQueryKeys.all(),
      });
      const count = variables.instituteIds.length;
      toast.success(
        count === 1
          ? 'Institute assigned successfully'
          : `${count} institutes assigned successfully`,
      );
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to assign institutes');
    },
  });
}
